const hviQuestionsEn = [
    {
        title: 'Do you find your everyday life meaningful?',
        type: 'numbers',
        hints: [
            '1 = on a few occasions during the week',
            '6 = every day there are meaningful moments'
        ],
    },
    {
        title: 'Do you feel you are in control when it comes to your stress levels in your everyday life?',
        type: 'numbers',
        hints: [
            '1 = I experience stress almost every day of the week',
            '6 = I experience stressful situations occasionally during a week'
        ],
    },
    {
        title: 'Do you think you are getting enough rest/recovery?',
        type: 'numbers',
        hints: [
            '1 = usually not',
            '6 = most of the time'
        ],
    },
    {
        title: 'Do you consider yourself to be getting enough sleep (amount and quality)?',
        type: 'numbers',
        hints: [
            '1 = usually not',
            '6 = most of the time'
        ],
    },
    {
        title: 'How is the balance between demands made on you and your resources at work?',
        type: 'numbers',
        hints: [
            "1 = the expectations from others and myself are too high and I can't handle them",
            "6 = I enjoy the expectations (others' and my own) and can handle them myself or with available support"
        ],
    },
    {
        title: 'How is your balance between demands and your resources at home?',
        type: 'numbers',
        hints: [
            "1 = the expectations from others and myself are too high and I can't handle them",
            "6 = I enjoy the expectations (others' and my own) and can handle them myself or with available support"
        ],
    },
    {
        title: 'How is your energy when you are at work?',
        type: 'numbers',
        hints: [
            '1 = most days I lack energy',
            '6 = my energy level is sufficient for most days'
        ],
    },
    {
        title: 'How is your energy when you are at home?',
        type: 'numbers',
        hints: [
            '1 = most days I lack energy',
            '6 = my energy level is sufficient for most days'
        ],
    },
    {
        title: 'Are you satisfied with your work performance?',
        type: 'numbers',
        hints: [
            '1 = I am often dissatisfied and think that what I do is not enough',
            '6 = I am mostly satisfied and think that what I do is enough'
        ],
    },
    {
        title: 'Are you satisfied with your free time?',
        type: 'numbers',
        hints: [
            '1 = I am often dissatisfied and think that what I do is not enough',
            '6 = I am mostly satisfied and think that what I do is enough'
        ],
    },
    {
        title: 'I can disconnect from work when I am free',
        type: 'numbers',
        hints: [
            '1 = usually not',
            '6 = most of the time'
        ],
    },
    {
        title: 'I can lay private matters aside when I am at work',
        type: 'numbers',
        hints: [
            '1 = usually not',
            '6 = most of the time'
        ],
    },
    
];

export default hviQuestionsEn;